import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DataService } from '../../data.service';
import { AuthService } from '../../users/auth.service';
import { Location } from '@angular/common';
import stateData from '../../shared/states.json';
import { Authority, newAuthority, Coord, newCoord } from '../authority';
import { HostListener } from '@angular/core';
import { Observable } from 'rxjs';
import { UserList } from 'src/app/users/user-list/user-list';
import { Validator } from '../../shared/validator';
import { Title } from '@angular/platform-browser';
import { EditGuard } from 'src/app/shared/edit.guard';

@Component({
  selector: 'pm-authority-edit',
  templateUrl: './authority-edit.component.html',
  styleUrls: ['./authority-edit.component.css']
})
export class AuthorityEditComponent implements OnInit {

  authorities: Authority[];
  authList: number[];
  authListPtr: number;
  currentAuthority: Authority;
  originalAuthority: Authority;
  user: UserList;
  users: UserList[];
  states=[];
  showDepartmentSearchBox: boolean;  
  showDivisionSearchBox: boolean;
  searchCoordTerms: string='';
  currentCoord: Coord=null;
  isAllowedBoard: boolean;  
  isAllowedDepartment: boolean;
  isAddMode: boolean=false;

   // https://stackoverflow.com/questions/54889941/how-to-use-math-min-or-math-max-syntax-in-angular-template
   get math() {
    return Math;
  }

  get authority() {
    return this.currentAuthority;
  }
  set authority(value) {
    this.currentAuthority = value;
    // Clone the object to retain a copy    
    this.originalAuthority = JSON.parse(JSON.stringify(value)); // Deep clone
  } 
  
  get coordsDefined(){
    return this.authority.coord.length>0;
  }

  constructor(public auth: AuthService, private dataService: DataService, private route: ActivatedRoute, private router:Router,
    private _location: Location, public v: Validator, private title: Title, private editGuard: EditGuard) { }

  ngOnInit() { 
    this.route.params.subscribe(
      params => {
          const id = +params['id'];
          this.getAuthority(id);
      }
    );
    
    let list=sessionStorage.getItem('authlist');
    if (list){      
      this.authList=JSON.parse(list);      
    }
    this.states=stateData;
    const id=this.route.snapshot.params['id'];
    this.dataService.getAllAuthorities().subscribe((data: Authority[])=>{
      this.authorities = data;
  //    console.log(data);
      this.getAuthority(id);
    });
    this.initCoordinatorList();
  }

  getAuthority(id){
    if (+id===0){
      this.isAddMode=true;
      this.authority=newAuthority(this.auth);
      if (this.authorities){
        const uniqueDept = [...new Set(this.authorities.map(a=>a.department))];
        if (uniqueDept.length==1)
          this.authority.department=this.authorities[0].department;
      //  this.authority.division=this.authorities[0].division;     // Nicole request 01/31/20
      }
      this.validateName();     
    }
    else {
      this.dataService.getAuthority(id).subscribe((data: Authority)=>{
        if (!data)
          this.router.navigateByUrl('/**');
        this.authority=data;
        this.title.setTitle(`Editing ${this.authority.department}/${this.authority.division}/${this.authority.board}`);
        this.validateName();
        this.authListPtr=this.authList.findIndex(x=>x===+id);
      })
    };
  }  

  resetCoordId(event,c: Coord) { 
    if (event.key=='Escape'){
      this.selectCoord(+c.coordId,c);
    }
  }

  initCoordinatorList() {
    if (!this.auth.isCoordinator){
      this.dataService.getAllUsers().subscribe((data: UserList[])=>{
        this.users=data;
  // - 0422      this.selectCoord(+this.authority.coord[i].coordId);
  // - 0422     this.authority=this.authority;
      });
    }
  }

  @HostListener('window:beforeunload')
    canDeactivate(): Observable<boolean> | boolean {
        if (this.editGuard.bypassMe)
          return true;  
        return !this.isDirty;
    }

  @ViewChild('authForm', {static: false}) authorityForm: any;

  get isDirty(): boolean {
    return JSON.stringify(this.originalAuthority) !== JSON.stringify(this.currentAuthority);
  }

  deleteAuth(){
    if (confirm ("Are you sure?")){
      this.dataService.deleteAuthority(this.authority.id).subscribe(()=>{
        const n=this.authList.indexOf(+this.authority.id);
        if (n>=0 && this.authList.length>1)
          this.authList.splice(n,1);
        this.goBack();}
      );
    }
  }

  getDepartment(){
    return this.authorities.map(a=>a.department);
  }

  getDivision(){
    return this.authorities.filter(a=>a.department==this.authority.department).map((a)=>a.division); 
  }

  goBack() {
    this._location.back();
  }

  filterDepartmentResults (name: any){
    const re=new RegExp(this.authority.department, 'gi');    
    return name.match(re);
  }

  // Almost identical to filterDepartmentResults
  filterDivisionResults (name: string){
    const re=new RegExp(this.authority.division, 'gi');    
    return name.match(re);
  }  
  
  filterCoordResults (user: any, coordTerms: string){
    const re=new RegExp(coordTerms, 'gi');
    return user.name.match(re);
  }

  removeCoord(coordId: string)
  {
    if (confirm("Remove this coordinator?")){
      let pos=this.authority.coord.findIndex(x=>+(x.coordId)===+coordId)
      if (pos>=0){
        this.authority.coord.splice(pos,1) ;
       }
    }   
  }

  addCoord(coordid?: number)
  { 
    let c=newCoord();
    this.authority.coord.push(c);
    console.log(this.authority);
  }

  selectDepartment(department: string)
  {
    this.authority.department=department;
    let a=this.authorities.find(c=>c.department===department);
    if (a){
      this.authority.division=a.division;
    }
    this.showDepartmentSearchBox=false;
    return false; // Apparently needed but why? 02/01/20
  }
    
  departmentBoxIn(){
    this.showDepartmentSearchBox=true;
    this.showDivisionSearchBox=false;
    this.currentCoord=null;
  }
  
  divisionBoxIn(){
    this.showDepartmentSearchBox=false;
    this.showDivisionSearchBox=true;
    this.currentCoord=null;
  }
  
  selectDivision(division: string){
    this.authority.division=division;
    this.showDivisionSearchBox=false;
    return false; // Apparently needed but why? 02/01/20
  }

  hideSearchBoxes(){
    this.showDepartmentSearchBox=false;
    this.showDivisionSearchBox=false;
    this.currentCoord=null;
  }
    
  validateName(){
    if (!this.authorities){
      this.isAllowedDepartment=true;
      return;
    }
    this.isAllowedDepartment=!!this.authorities.find(f=>f.department==this.authority.department)|| !this.auth.isCoordinator;
    let a=this.authorities.find(f=>f.department===this.authority.department &&
      f.division===this.authority.division && f.board===this.authority.board && f.id !== +this.authority.id );
    this.isAllowedBoard=!a;
    // console.log('In validate name', this.isAllowedDepartment, this.authority, a);
  }
  
  selectCoord(id: number, c:Coord){
    this.user=this.users.find(c=>c.id===id);
    if (id>=0){
      c.coordName=this.user.name;
      c.coordEmail=this.user.email;
      c.coordPhone=this.user.telephone;  
      c.coordExt=this.user.teleExt
      c.coordId=(1000+id).toString().substring(1);
    }
    else {
      c.coordName=c.coordEmail=c.coordPhone='';
      c.coordId='000';
    }
    this.currentCoord=null;
    //if (this.authorityForm.form.controls['searchCoordTerms'])
    //  this.authorityForm.form.controls['searchCoordTerms'].status='VALID';
    return false; // Required
  }
  
  coordBoxIn(coord: Coord){
    this.currentCoord=coord;
  }
  
  update():void {
    if (this.v.validate(this.authorityForm))
    {
      this.dataService.updateAuthority(this.authority).subscribe((data: number)=>{
        this.authority.id=data;
        this.authority=this.authority;  // Current now original
//        this.goBack();
      });
    }
  }  
}